import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import { Snackbar } from 'rmwc/Snackbar';
import StatusMessage from '../../util/StatusMessage'
import TQAdminIndividualResource from './TQAdminIndividualResource';

class TQAdminResourcePage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            uploadDisableButton: false,
            snackbarIsOpen: false,
            uploadFormOpen: false,
            addFormOpen: false,
            errorMsg: '',
    		data:{
                resourceDetails: []
    		},
            inputData:{
                resourceName: '',
                resourceLink: '',
                resourceAuthor: '',
                resourceDescription: ''
            },
            fileError: ''
    	}
    }

    handleUploadFormOpen = (e) => {
        e.preventDefault()
        this.setState({ uploadFormOpen: true, addFormOpen: false, errorMsg: '' });
    }

    handleAddFormOpen = (e) => {
        e.preventDefault()
        this.setState({ uploadFormOpen: false, addFormOpen: true, errorMsg: ''});
    }

    handleUploadFormClose = (e) => {
        e.preventDefault()
        let intData = Object.assign({}, this.state.inputData)
        intData = {
            'resourceName' : '',
            'resourceAuthor': '',
            'resourceDescription': ''
        }
        this.setState({uploadFormOpen: false, addFormOpen: false, inputData: intData, errorMsg: ''})
    }

    handleAddFormClose = (e) => {
        e.preventDefault()
        let intData = Object.assign({}, this.state.inputData)
        intData = {
            'resourceName' : '',
            'resourceLink' : '',
            'resourceAuthor': '',
            'resourceDescription': ''
        }
        this.setState({uploadFormOpen: false, addFormOpen: false, inputData: intData, errorMsg: ''})
    }

    handleNameChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.resourceName = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleLinkChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.resourceLink = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleAuthorChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.resourceAuthor = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleDescChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.resourceDescription = event.target.value
        this.setState({inputData: inputData}) 
    }

    validateUpload = (event) =>{
        let file_name = event.target.files[0].name;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();
        let uploadDisableButton
        let fileError

        if (extension == "pdf"){
            uploadDisableButton = false
            fileError = ''
            this.setState({uploadDisableButton: uploadDisableButton, fileError: fileError})
        }
        else{
            uploadDisableButton = true
            fileError = 'Invalid File Format. Upload PDF file only.'
            this.setState({uploadDisableButton: uploadDisableButton, fileError: fileError})
        }
    }

    handleResourceUpload =(e) =>{
        let uploadDisableButton
        e.preventDefault()
        if ((this.state.inputData.resourceName == '') || (this.state.inputData.resourceAuthor == '') || (this.state.inputData.resourceDescription == '')) {
            return this.setState({errorMsg: 'Please enter the necessary details before uploading a new resource.'})
        }

        const formData = new FormData(e.target);

        uploadDisableButton = true
        this.setState({uploadDisableButton: uploadDisableButton})

        api.uploadAdminTQResource(this.props.user.accessToken,formData)
        .then((result) => {
            if(result.status == 'success'){
                let inputData = Object.assign({}, this.state.inputData)
                inputData = {
                    'resourceName' : '',
                    'resourceDescription': '',
                    'resourceAuthor': ''
                }

                let data = Object.assign({}, this.state.data)
                uploadDisableButton = false
                api.fetchAdminTQResource(this.props.user.accessToken)
                .then((result) => {
                    data.resourceDetails = result.data
                    this.setState({data: data, uploadDisableButton: uploadDisableButton})
                })
                this.setState({snackbarIsOpen: !this.state.snackbarIsOpen, uploadFormOpen: false, inputData: inputData, errorMsg: '', uploadDisableButton: uploadDisableButton})
            } else{
                this.setState({ errorMsg: 'Error while uploading a new TQ resource.', uploadDisableButton: false})
            }
        })
        .catch((err) => {
            this.setState({ errorMsg: 'Error in uploading the resource. Please contact Admin!', uploadDisableButton: false })
        })
    }

    handleResourceAdd = (e) => {
        e.preventDefault()
        if ((this.state.inputData.resourceName == '') || (this.state.inputData.resourceAuthor == '') || (this.state.inputData.resourceLink == '') || (this.state.inputData.resourceDescription == '')) {
            return this.setState({errorMsg: 'Please enter the necessary details before adding a new resource.'})
        }

        this.setState({uploadDisableButton: true})
        let data = {
            'name' : this.state.inputData.resourceName,
            'resourceLink' : this.state.inputData.resourceLink,
            'resourceAuthor': this.state.inputData.resourceAuthor,
            'resourceDesc': this.state.inputData.resourceDescription
        }
        api.addAdminTQResource(this.props.user.accessToken, data)
        .then((result) => {
            if (result.status == 'success') {
                let inputData = Object.assign({}, this.state.inputData)
                inputData = {
                    'resourceName' : '',
                    'resourceLink' : '',
                    'resourceDescription': '',
                    'resourceAuthor': ''
                }
                let data = Object.assign({}, this.state.data)
                api.fetchAdminTQResource(this.props.user.accessToken)
                .then((result) => {
                    data.resourceDetails = result.data
                    this.setState({data: data})
                })
                this.setState({addFormOpen: false, inputData: inputData, errorMsg: '', uploadDisableButton: false})
            } else{
                this.setState({ errorMsg: 'Error while adding a new TQ resource.', uploadDisableButton: false, uploadDisableButton: false })
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in adding the resource. Please contact Admin!', uploadDisableButton: false })
        })
    }

    componentDidMount(){
        let data = Object.assign({}, this.state.data)

        return api.fetchAdminTQResource(this.props.user.accessToken)
        .then((result) => {
            data.resourceDetails = result.data
            this.setState({data: data})
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in Fetching TQ Resources. Please contact Admin!' })
        })
    }

    render () {
        let inputAddComponent
        let resourceComponent
        let uploadButtonComponent
        let handleResourceUpload = this.handleResourceUpload
        let handleResourceAdd = this.handleResourceAdd
        let handleUploadFormClose = this.handleUploadFormClose
        let handleUploadFormOpen = this.handleUploadFormOpen
        let handleAddFormOpen = this.handleAddFormOpen
        let handleAddFormClose = this.handleAddFormClose

        let Snackbarcomponent =(
            <Snackbar
                show={this.state.snackbarIsOpen}
                onHide={evt => this.setState({snackbarIsOpen: false})}
                message="Upload Successful"
            />
        )

        if(this.state.uploadDisableButton == false){
            uploadButtonComponent = (<Button raised style={{ width: '100%' }}>Save</Button>)
        }
        else{
            uploadButtonComponent = (<Button raised disabled style={{ width: '100%' }}>Save</Button>)
        }


        if (this.state.uploadFormOpen){
            inputAddComponent = (
                <div>
                    <form style={{ width: '100%' }} onSubmit= {((e) => this.handleResourceUpload(e))}>
                    <Grid className="opportunity-list-item">
                        <GridCell span="9">
                            <TextField fullwidth className = 'test_input' label="Name of the Resource" autoComplete="off"  name="resourcename" value = {this.state.inputData.resourceName} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="3">
                            <TextField fullwidth label="Author" name="resourceauthor" value = {this.state.inputData.resourceAuthor} onChange={this.handleAuthorChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="9">
                            <TextField textarea fullwidth label="Description" rows="1" name="resourcedesc" value = {this.state.inputData.resourceDescription} onChange={this.handleDescChange} />
                        </GridCell>
                        <GridCell span="3">
                            <input type="file" id="PdfUpload" name="artifact" onChange={this.validateUpload} />
                        </GridCell>
                        <GridCell span="4"> 
                            {uploadButtonComponent}
                        </GridCell>
                        <GridCell span="4">
                            <Button style={{ width: '100%' }} onClick= {((e) => handleUploadFormClose(e))}>Cancel </Button>
                        </GridCell>
                        <GridCell span="2">
                        </GridCell>
                    </Grid>
                    </form>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                </div>
            )
        }

        if (this.state.addFormOpen){
            inputAddComponent = (
                <div>
                    <Grid className="opportunity-list-item">
                        <GridCell span="5">
                            <TextField fullwidth className = 'test_input' label="Name of the Resource" autoComplete="off"  name="resourcename" value = {this.state.inputData.resourceName} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="7">
                            <TextField fullwidth className = 'test_input' label="Link for the Resource" autoComplete="off"  name="resourcelink" value = {this.state.inputData.resourceLink} onChange = {this.handleLinkChange} style={{ height: '140%' }}/>
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span="3">
                            <TextField fullwidth label="Author" name="resourceauthor" value = {this.state.inputData.resourceAuthor} onChange={this.handleAuthorChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="9">
                            <TextField textarea fullwidth label="Description" rows="1" name="resourcedesc" value = {this.state.inputData.resourceDescription} onChange={this.handleDescChange} />
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span="4"> 
                            <Button raised style={{ width: '100%' }} onClick= {((e) => this.handleResourceAdd(e))}>Save</Button>
                        </GridCell>
                        <GridCell span="4">
                            <Button style={{ width: '100%' }} onClick= {((e) => handleAddFormClose(e))}>Cancel </Button>
                        </GridCell>
                        <GridCell span="2">
                        </GridCell>
                    </Grid>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                </div>
            )
        }

        if(this.state.data.resourceDetails.length>0){
            resourceComponent = (
                <div>
                    {this.state.data.resourceDetails.map(function(resource){
                        return(<TQAdminIndividualResource tqResourceId = {resource.id}
                            tqResourceName = {resource.name}
                            tqResourceLink = {resource.resource_link}
                            tqResourceType = {resource.resource_type}
                            tqResourceAuthor = {resource.author}
                            tqResourceDescription = {resource.description} 
                            tqResourceRating = {resource.rating}
                            tqResourceDate = {resource.date}/>
                        )
                    })}
                </div>
            )
        }

    	return (
            <div>
        		<Grid>
                    <GridCell span="12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5"> TQ Learning Resources </Typography>
                        </Card>
                    </GridCell>
                </Grid>
                <Grid>
                    <GridCell span="10">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline6" align="left" >List of Resources  <Button dense style={{ width: '10%' }} onClick= {((e) => handleUploadFormOpen(e))}>Upload</Button> <Button dense style={{ width: '10%' }} onClick= {((e) => handleAddFormOpen(e))}>Add</Button> </Typography>
                            {inputAddComponent}
                            <StatusMessage error_msg = {this.state.errorMsg} />
                            <StatusMessage error_msg = {this.state.fileError} />
                            {resourceComponent}
                        </Card>
                        {Snackbarcomponent}
                    </GridCell>
                </Grid>
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TQAdminResourcePage);


// WEBPACK FOOTER //
// ./src/views/admin/TQAdminResourcePage.jsx